import HeaderBarComponent from 'd2-ui/lib/app-header/HeaderBar';
import headerBarStore$ from 'd2-ui/lib/app-header/headerBar.store';
import withStateFrom from 'd2-ui/lib/component-helpers/withStateFrom';

export default withStateFrom(headerBarStore$, HeaderBarComponent);



// WEBPACK FOOTER //
// ./src/header/HeaderBar.js